// extracted by mini-css-extract-plugin
export default {"container":"ddc77ef1"};